<template>
  <ul class="nav nav-mobile-menu">
    <li>
      <drop-down>
        <a slot="title" class="dropdown-toggle" data-toggle="dropdown">
          <i class="material-icons">notifications</i>
          <span class="notification">{{ notifications.length }}</span>
          <p>Notificações</p>
        </a>
        <ul class="dropdown-menu dropdown-menu-right">
          <li
            v-for="(notification, i) in notifications"
            :key="`notification-${i}`"
          >
            <router-link :to="notification.link">{{
              notification.message
            }}</router-link>
          </li>
        </ul>
      </drop-down>
    </li>
  </ul>
</template>
<script>
import { updateList } from "../../helpers";

export default {
  computed: {
    unsignedContracts() {
      return this.$store.getters.unsignedContracts;
    },
    points() {
      return this.$store.getters.points;
    },
    notifications() {
      const messages = [];
      if (this.unsignedContracts.length > 0) {
        messages.push({
          link: "/contracts",
          message: `Você possui ${this.unsignedContracts.length} contrato(s) pendente(s)!`
        });
      }

      // const updatable = this.points.filter(p => updateList.has(p.plan_id));
      // if (updatable.length > 0) {
      //   messages.push({
      //     link: "/services",
      //     message: `${updatable.length} planos podem ser atualizados!`
      //   });
      // }
      return messages;
    }
  },
  data() {
    return {};
  }
};
</script>

<style scoped>
.dropdown-toggle:after {
  margin-top: 11px;
  margin-left: 1.255em;
}
</style>
